@if (hasExpandEventListener && !$isClosed()) {
  <button class="expand-button" (click)="toggleExpand()" [class.expand-button--open]="isExpanded">
    <mat-icon>{{ isExpanded ? 'chevron_left' : 'chevron_right' }}</mat-icon>
  </button>
}

@if (isMobile() && swipePosition()) {
  <button (click)="toogleMobilePanel()" class="swipe-button-iphone">
    <mat-icon>
      {{ this.currentSwipePostion() === 'closed' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </mat-icon>
  </button>
}
<!-- Render the content only once the panel is fully open, so the projected
     elements (e.g. the map) are laid out and initialized at the final width. -->
@if (!isTransitioning()) {
  <div class="panel-content">
    <ng-content></ng-content>
  </div>
}
